<template>
  <RouterLink
    :to="{ name: routeName }"
    class="group/nav-link group flex cursor-default flex-col rounded-md p-1.5 pl-2.5 hover:bg-primary-400 hover:text-white dark:text-white"
    :class="[
      isActive
        ? 'bg-primary-500 font-medium text-white hover:bg-primary-500 hover:text-white'
        : '',
      indent ? 'ml-5' : ''
    ]"
  >
    <div class="flex flex-1 flex-row space-x-2">
      <div class="shrink-0">
        <FontAwesomeIcon :icon="['fal', icon]" fixed-width />
      </div>
      <div class="flex flex-1 cursor-pointer flex-row gap-2">
        <span class="truncate capitalize-first">{{ label }}</span>
      </div>
      <div
        v-if="newRouteName"
        class="flex aspect-square shrink-0 cursor-pointer items-center rounded bg-white px-0.5 text-primary opacity-0 group-hover/nav-link:opacity-100"
        :title="$t('button.add')"
        @click.stop.prevent="$router.push({ name: newRouteName })"
      >
        <FontAwesomeIcon :icon="['fal', 'plus']" fixed-width />
      </div>
    </div>
  </RouterLink>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Entry of the invoicing menu, styled as Funeral Manager's InvoicingNavLink.
 * `newRouteName` adds the hover "+" that creates a document of that type.
 */
export default {
  name: 'InvoicingMenuLink',
  components: { FontAwesomeIcon },
  props: {
    routeName: { type: String, required: true },
    icon: { type: String, required: true },
    label: { type: String, required: true },
    newRouteName: { type: String, required: false, default: null },
    indent: { type: Boolean, required: false, default: false }
  },
  computed: {
    isActive() {
      return this.$route.name === this.routeName
    }
  }
}
</script>
